// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_jg-0";
export var buttonContainer = "_jg-3";
export var cancelButton = "_jg-4";
export var headerSection = "_jg-6";
export var headerTitle = "_jg-9";
export var messageSideLeft = "_jg-1";
export var messageSideRight = "_jg-2";
export var orderNumberContainer = "_jg-7";
export var orderNumberLabel = "_jg-8";
export var submitButton = "_jg-5";